




























import Vue, { PropType } from "vue";

export interface ProgressCircleProps {
  size: number;
}

export interface ScreenLockData {
  radius: number;
  strokeWidth: number;
}

export default Vue.extend({
  name: "vc-progress-circle",
  props: {
    size: {
      type: Number as PropType<ProgressCircleProps["size"]>,
      default: 30
    }
  },
  data(): ScreenLockData {
    return {
      radius: 20,
      strokeWidth: 5
    };
  },
  computed: {
    // svg の描画領域 (vuetify の git を参考)
    viewBoxSize(): number {
      return this.radius / (1 - Number(this.strokeWidth) / +this.size);
    }
  }
});
